// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Partners {
  /* Visual container for partners content. The PageSection now provides the
    full-width background so this element should be transparent and inherit
    text color from its parent. Inner \`.Partners-inner\` keeps content centered. */
  background: transparent;
  color: inherit;
  padding: 0;
  position: relative;
  width: 100%;
  box-shadow: none;
  border: none;
}
.Partners-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
}
.Partners-heading {
  font-size: 6rem;
  margin: 0 0 8px 0;
  /* glossy white text effect: gradient clipped to text with subtle shine */
  color: #ffffff; /* fallback */
  background: linear-gradient(180deg, #ffffff 0%, #e6eef8 45%, #d9e6f5 55%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 1px 0 rgba(255,255,255,0.35), 0 2px 6px rgba(0,0,0,0.45);
}
.Partners-lead {
  font-size: 1rem;
  font-style: italic;
  margin: 0 0 12px 0;
  /* glossy-ish white for the lead but slightly muted */
  color: #f8fafc;
  text-shadow: 0 1px 0 rgba(255,255,255,0.15), 0 1px 3px rgba(0,0,0,0.35);
}
.Partners-grid {
  display: grid;
  /* responsive columns: increase the min column width so much larger logos have room.
     With only two partners this will center them nicely. */
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 32px;
  align-items: center;
  justify-items: center;
  width: 100%;
}
.Partner-card {
  /* remove the white card background so logos sit directly on the section
     background. Keep spacing and alignment so layout remains stable. */
  background: transparent;
  border-radius: 8px; /* keep slight rounding in case you later add hover */
  padding: 12px 8px; /* small padding to give logos breathing room */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  width: 100%;
  /* increased max-width to accommodate larger partner logos */
  max-width: 480px;
  box-sizing: border-box;
}
.Partner-logo-wrap {
  /* configurable logo display size — tweak the vars below to change scale */
  /* set to ~4x the original small logo container (originally 84x48) */
  /* increased default (desktop) partner logo size */
  --partner-logo-w: 420px;
  --partner-logo-h: 240px;
  width: var(--partner-logo-w);
  height: var(--partner-logo-h);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  background: transparent;
}
.Partner-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.Partner-name { display: none; }

/* Protocol logos row shown beneath partner grid */
.Partner-protocols {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.Partner-protocol-logo {
  /* square tile look */
  width: 160px;
  height: 160px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
  background: transparent; /* show image transparency */
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  transition: transform 220ms cubic-bezier(.2,.9,.2,1), box-shadow 220ms ease;
  will-change: transform, box-shadow;
  cursor: pointer;
}

/* Hover / focus interaction for protocol tiles */
.Partner-protocol-logo:hover,
.Partner-protocol-logo:focus,
.Partner-protocol-logo:focus-visible {
  transform: translateY(-6px) scale(1.06);
  box-shadow: 0 12px 30px rgba(0,0,0,0.22);
  outline: none;
}

/* Respect user's reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .Partner-protocol-logo {
    transition: none;
    transform: none;
  }
  .Partner-protocol-logo:hover,
  .Partner-protocol-logo:focus,
  .Partner-protocol-logo:focus-visible {
    transform: none;
    box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  }
}

/* Small heading displayed above protocols */
.Partner-protocols-heading {
  margin: 28px 0 8px;
  text-align: center;
  font-size: 1.1rem;
  color: #f8fafc;
  opacity: 0.95;
  font-weight: 600;
}

@media (max-width: 900px) {
  .Partners-grid { grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }
  /* bump tablet sizes to match increased desktop scale */
  .Partner-card { max-width: 420px; padding: 14px; }
  .Partner-logo-wrap { --partner-logo-w: 360px; --partner-logo-h: 200px; }
  .Partner-name { font-size: 0.85rem; }
}
@media (max-width: 480px) {
  .Partners-grid { grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); }
  /* allow larger logos on mobile while keeping layout intact */
  .Partner-card { max-width: 360px; padding: 10px; }
  .Partner-logo-wrap { --partner-logo-w: 320px; --partner-logo-h: 180px; }
  .Partner-name { font-size: 0.8rem; }
  .Partner-protocol-logo { width: 120px; height: 120px; }
}
`, "",{"version":3,"sources":["webpack://./src/css/Partners.css"],"names":[],"mappings":"AAAA;EACE;;iFAE+E;EAC/E,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yEAAyE;EACzE,cAAc,EAAE,aAAa;EAC7B,uFAAuF;EACvF,6BAA6B;EAC7B,oCAAoC;EACpC,uEAAuE;AACzE;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,uEAAuE;AACzE;AACA;EACE,aAAa;EACb;2DACyD;EACzD,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE;uEACqE;EACrE,uBAAuB;EACvB,kBAAkB,EAAE,qDAAqD;EACzE,iBAAiB,EAAE,+CAA+C;EAClE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,4DAA4D;EAC5D,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,0EAA0E;EAC1E,oEAAoE;EACpE,kDAAkD;EAClD,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;AACA,gBAAgB,aAAa,EAAE;;AAE/B,kDAAkD;AAClD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,uBAAuB,EAAE,4BAA4B;EACrD,uCAAuC;EACvC,2EAA2E;EAC3E,kCAAkC;EAClC,eAAe;AACjB;;AAEA,iDAAiD;AACjD;;;EAGE,uCAAuC;EACvC,wCAAwC;EACxC,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;;;IAGE,eAAe;IACf,uCAAuC;EACzC;AACF;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,2DAA2D,EAAE;EAC9E,uDAAuD;EACvD,gBAAgB,gBAAgB,EAAE,aAAa,EAAE;EACjD,qBAAqB,uBAAuB,EAAE,uBAAuB,EAAE;EACvE,gBAAgB,kBAAkB,EAAE;AACtC;AACA;EACE,iBAAiB,2DAA2D,EAAE;EAC9E,6DAA6D;EAC7D,gBAAgB,gBAAgB,EAAE,aAAa,EAAE;EACjD,qBAAqB,uBAAuB,EAAE,uBAAuB,EAAE;EACvE,gBAAgB,iBAAiB,EAAE;EACnC,yBAAyB,YAAY,EAAE,aAAa,EAAE;AACxD","sourcesContent":[".Partners {\n  /* Visual container for partners content. The PageSection now provides the\n    full-width background so this element should be transparent and inherit\n    text color from its parent. Inner `.Partners-inner` keeps content centered. */\n  background: transparent;\n  color: inherit;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  box-shadow: none;\n  border: none;\n}\n.Partners-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n.Partners-heading {\n  font-size: 6rem;\n  margin: 0 0 8px 0;\n  /* glossy white text effect: gradient clipped to text with subtle shine */\n  color: #ffffff; /* fallback */\n  background: linear-gradient(180deg, #ffffff 0%, #e6eef8 45%, #d9e6f5 55%, #ffffff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: 0 1px 0 rgba(255,255,255,0.35), 0 2px 6px rgba(0,0,0,0.45);\n}\n.Partners-lead {\n  font-size: 1rem;\n  font-style: italic;\n  margin: 0 0 12px 0;\n  /* glossy-ish white for the lead but slightly muted */\n  color: #f8fafc;\n  text-shadow: 0 1px 0 rgba(255,255,255,0.15), 0 1px 3px rgba(0,0,0,0.35);\n}\n.Partners-grid {\n  display: grid;\n  /* responsive columns: increase the min column width so much larger logos have room.\n     With only two partners this will center them nicely. */\n  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));\n  gap: 32px;\n  align-items: center;\n  justify-items: center;\n  width: 100%;\n}\n.Partner-card {\n  /* remove the white card background so logos sit directly on the section\n     background. Keep spacing and alignment so layout remains stable. */\n  background: transparent;\n  border-radius: 8px; /* keep slight rounding in case you later add hover */\n  padding: 12px 8px; /* small padding to give logos breathing room */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n  width: 100%;\n  /* increased max-width to accommodate larger partner logos */\n  max-width: 480px;\n  box-sizing: border-box;\n}\n.Partner-logo-wrap {\n  /* configurable logo display size — tweak the vars below to change scale */\n  /* set to ~4x the original small logo container (originally 84x48) */\n  /* increased default (desktop) partner logo size */\n  --partner-logo-w: 420px;\n  --partner-logo-h: 240px;\n  width: var(--partner-logo-w);\n  height: var(--partner-logo-h);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n  background: transparent;\n}\n.Partner-logo {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n.Partner-name { display: none; }\n\n/* Protocol logos row shown beneath partner grid */\n.Partner-protocols {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n.Partner-protocol-logo {\n  /* square tile look */\n  width: 160px;\n  height: 160px;\n  object-fit: cover;\n  display: block;\n  border-radius: 8px;\n  background: transparent; /* show image transparency */\n  box-shadow: 0 6px 18px rgba(0,0,0,0.12);\n  transition: transform 220ms cubic-bezier(.2,.9,.2,1), box-shadow 220ms ease;\n  will-change: transform, box-shadow;\n  cursor: pointer;\n}\n\n/* Hover / focus interaction for protocol tiles */\n.Partner-protocol-logo:hover,\n.Partner-protocol-logo:focus,\n.Partner-protocol-logo:focus-visible {\n  transform: translateY(-6px) scale(1.06);\n  box-shadow: 0 12px 30px rgba(0,0,0,0.22);\n  outline: none;\n}\n\n/* Respect user's reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .Partner-protocol-logo {\n    transition: none;\n    transform: none;\n  }\n  .Partner-protocol-logo:hover,\n  .Partner-protocol-logo:focus,\n  .Partner-protocol-logo:focus-visible {\n    transform: none;\n    box-shadow: 0 6px 18px rgba(0,0,0,0.12);\n  }\n}\n\n/* Small heading displayed above protocols */\n.Partner-protocols-heading {\n  margin: 28px 0 8px;\n  text-align: center;\n  font-size: 1.1rem;\n  color: #f8fafc;\n  opacity: 0.95;\n  font-weight: 600;\n}\n\n@media (max-width: 900px) {\n  .Partners-grid { grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); }\n  /* bump tablet sizes to match increased desktop scale */\n  .Partner-card { max-width: 420px; padding: 14px; }\n  .Partner-logo-wrap { --partner-logo-w: 360px; --partner-logo-h: 200px; }\n  .Partner-name { font-size: 0.85rem; }\n}\n@media (max-width: 480px) {\n  .Partners-grid { grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); }\n  /* allow larger logos on mobile while keeping layout intact */\n  .Partner-card { max-width: 360px; padding: 10px; }\n  .Partner-logo-wrap { --partner-logo-w: 320px; --partner-logo-h: 180px; }\n  .Partner-name { font-size: 0.8rem; }\n  .Partner-protocol-logo { width: 120px; height: 120px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
